import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	altText: {
		id: 'polaris-lib.team-value.team-avatar',
		defaultMessage: 'Team avatar',
		description: 'Alt text for the team avatar image',
	},
});
